import { render, staticRenderFns } from "./workload-edit.vue?vue&type=template&id=49e26f2b&scoped=true&"
import script from "./workload-edit.vue?vue&type=script&lang=js&"
export * from "./workload-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e26f2b",
  null
  
)

export default component.exports